import { Component } from '@angular/core';
import { MAPSContactMessageEventEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Contact Message Events') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-mapscontactmessageevent-form',
    templateUrl: './mapscontactmessageevent.form.component.html'
})
export class MAPSContactMessageEventFormComponent extends BaseFormComponent {
    public record!: MAPSContactMessageEventEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

